import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateWebhookConfigurationMutation = createMutationHook(
  WebhooksApiClient.createWebhookConfiguration,
  {
    mutationKey: ['createWebhookConfiguration'],
  },
)
